//**************************************************************************************************
//  ヘッダー
//**************************************************************************************************
//==================================================================================================
//  import
//==================================================================================================
import { Component, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';

import { CommonModule } from '@angular/common';

import { TranslateService, TranslatePipe } from "@ngx-translate/core";

import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';

import { PushmessageFireService } from '../../function/pushmessage/pushmessage-service/pushmessage-fire.service';

import { AppConst } from '../../app-const';

import { SessionService } from '../service/session.service';
import { Session }  from '../../class/session';

import { FireSysAdmin } from '../../class/fire/sys_admin';
import { FireOpAdmin } from '../../class/fire/op_admin';
import { FireOpUser } from '../../class/fire/op_user';
import { FireGroup } from '../../class/fire/group';
import { FireOpr } from '../../class/fire/opr';
//==================================================================================================
//  Component
//==================================================================================================
@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    TranslatePipe,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
//==================================================================================================
//  class
//==================================================================================================
export class HeaderComponent {
  //================================================================================================
  //  @ViewChild  （HTML内の要素との紐付けを宣言）
  //============================|===================================================================
  @Output() sidenavClose        = new EventEmitter();
  @Output() sidenavToggle       = new EventEmitter();
  //================================================================================================
  //  変数定義
  //============================|===================================================================
  isLogin                       : boolean                 = false;                                  //  ログイン
  isAuthS                       : boolean                 = false;                                  //  システム管理者
  isAuthO                       : boolean                 = false;                                  //  OP管理者
  isAuthU                       : boolean                 = false;                                  //  一般ユーザー
  isGroup                       : boolean                 = false;                                  //  グループ
  isOpr                         : boolean                 = false;                                  //  OPレジストリ
  //------------------------------------------------------------------------------------------------
  sessionUid                    : string | null           = null;                                   //  セッション情報：UID
  sessionSysAdmin               : FireSysAdmin | null     = null;                                   //  セッション情報：システム管理者
  sessionOpAdmin                : FireOpAdmin | null      = null;                                   //  セッション情報：OP管理者
  sessionOpUser                 : FireOpUser | null       = null;                                   //  セッション情報：CAユーザー
  sessionGroup                  : FireGroup | null        = null;                                   //  セッション情報：グループ
  sessionOpr                    : FireOpr | null          = null;                                   //  セッション情報：OPレジストリ
  //------------------------------------------------------------------------------------------------
  ssPushmessage                 = new Subscription();
  ssPushmessage_flag            = false;
  //------------------------------------------------------------------------------------------------
  private configSucces          : MatSnackBarConfig = {
    panelClass                    : ['style-succes'],
  };
  private configWarning         : MatSnackBarConfig = {
    panelClass                    : ['style-warning'],
  };
  private configError           : MatSnackBarConfig = {
    panelClass                    : ['style-error'],
  };
  currentLang                   : string                  = "日本語"
  //================================================================================================
  //  コンストラクタ
  //================================================================================================
  constructor(
    private sessionService: SessionService,
    private pushmessageFireService: PushmessageFireService,
    private router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService) { }
  //================================================================================================
  //  初期処理
  //================================================================================================
  ngOnInit(): void {
    //----------------------------------------------------------------------------------------------
    if (this.translate.currentLang == 'en') {
      this.currentLang = "English";
    } else {
      this.currentLang = "日本語";
    }
    //----------------------------------------------------------------------------------------------
    this.sessionService.sessionState.subscribe((session: Session)=> {
      if (session) {
        this.isLogin              = session.isLogin;
        this.sessionUid           = session.uid;
        this.sessionSysAdmin      = session.sysAdmin;
        this.sessionOpAdmin       = session.opAdmin;
        this.sessionOpUser        = session.opUser;
        this.sessionGroup         = session.group;
        this.sessionOpr           = session.opr;
        //------------------------------------------------------------------------------------------
        this.isAuthS              = !!this.sessionSysAdmin ?      true : false;
        this.isAuthO              = !!this.sessionOpAdmin ?       true : false;
        this.isAuthU              = !!this.sessionOpUser ?        true : false;
        this.isGroup              = !!this.sessionGroup ?  true : false;
        this.isOpr                = !!this.sessionOpr ?           true : false;
        //------------------------------------------------------------------------------------------
        let email               = null;
        if (!!this.sessionSysAdmin) {
          email = this.sessionSysAdmin.email;
        } else {
          if (!!this.sessionOpAdmin) {
            email = this.sessionOpAdmin.email;
          } else {
            if (!!this.sessionOpUser) {
              email = this.sessionOpUser.email;
            }
          }
        }
        //------------------------------------------------------------------------------------------
        if (!!email) {
          if (!this.ssPushmessage_flag) {
            this.ssPushmessage_flag = true;
            this.ssPushmessage.unsubscribe();
            this.ssPushmessage = new Subscription();
            this.ssPushmessage.add(
              this.pushmessageFireService.getData(email).subscribe(data => {
                if (!!data) {
                  let now_time      = new Date();                                                   //  現在日時
                  let now_time_msec = now_time.getTime();                                           //  現在日時：ミリ秒
                  let update_dt     = data.update_dt!.toMillis();                                   //  更新日時：ミリ秒
                  let progress      = 1 * 60 * 1000;                                                //  経過時間：１分
                  if (now_time_msec < update_dt + progress) {                                       //  現在日時が更新日時＋経過時間未満ならポップアップ表示
                    if (data.type == 1) {
                      this.snackBar.open(this.translate.instant('TS-header.'+data.message), this.translate.instant('TS-header.'+data.action), {
                        duration: 5000,
                        panelClass: ['snackbar-success']
                      });
                    } else if (data.type == 2) {
                      this.snackBar.open(this.translate.instant('TS-header.'+data.message), this.translate.instant('TS-header.'+data.action), {
                        duration: 10000,
                        panelClass: ['snackbar-warning']
                      });
                    } else if (data.type == 3) {
                      this.snackBar.open(this.translate.instant('TS-header.'+data.message), this.translate.instant('TS-header.'+data.action), {
                        duration: 30000,
                        panelClass: ['snackbar-error']
                      });
                    } else {
                      this.snackBar.open(this.translate.instant('TS-header.'+data.message), this.translate.instant('TS-header.'+data.action), {
                        duration: 3000,
                        panelClass: ['snackbar-success']
                      });
                    }
                  }
                }
              })
            );
          }
        } else {
          this.ssPushmessage_flag = false;
          this.ssPushmessage.unsubscribe();
        }
        //------------------------------------------------------------------------------------------
      }
    })
  }
  //================================================================================================
  //  終了処理
  //================================================================================================
  ngOnDestroy(): void {
    this.ssPushmessage.unsubscribe();
  }
  //================================================================================================
  //  ログアウト
  //================================================================================================
  logout(): void {
    this.sidenavClose.emit();
    this.sessionService.logout();
  }
  //================================================================================================
  //  言語
  //================================================================================================
  language(lang: string): void {
    this.translate.use(lang);
    localStorage.setItem('opca_language', lang);
    //----------------------------------------------------------------------------------------------
    if (lang == 'en') {
      this.currentLang = "English";
    } else {
      this.currentLang = "日本語";
    }
    //----------------------------------------------------------------------------------------------
  }
  //================================================================================================
  //  メニュー
  //================================================================================================
  menu(): void {
    this.sidenavToggle.emit();
  }
  //================================================================================================
  //  グループ画面へ
  //================================================================================================
  goto1(): void {
    if (!!this.sessionSysAdmin) {
      this.sessionService.setGroup(null);
      this.router.navigate(['/group']);
    }
  }
  //================================================================================================
  //  OP画面へ
  //================================================================================================
  goto2(): void {
    if (!!this.sessionSysAdmin || !!this.sessionOpAdmin || !!this.sessionOpUser) {
      this.sessionService.setOpr(null);
      this.router.navigate(['/opr']);
    }
  }
  //================================================================================================
  //  印刷ボタン
  //================================================================================================
  onPrintScreenClick() {
    window.print();
  }
}
